import { toggle } from "@otto-ec/global-resources/toggle";
import type { CustomElement } from "./utils";
import { extendElementAsFormAssociated } from "./extend.formAssociated";
import { extendElementWithInputBehavior } from "./extend.inputBehavior";
import { extendElementBase } from "./extend.base";
import { extendElementWithRenderSliceInit } from "./extend.initializers";

window.__components ??= {} as never;
window.__components.extend =
  /**
 *
 */
  ({ formAssociated, inputBehavior } = {}) =>
    /**
 *
 */
    (customElement) => {
      let result = extendElementBase(customElement as CustomElement);

      /*                                                */
      if (toggle.get("oc_init_with_render_slice", false)) {
        result = extendElementWithRenderSliceInit(result);
      }

      /*                                                               */
      if (formAssociated) result = extendElementAsFormAssociated(result);

      /*                                               */
      if (inputBehavior) result = extendElementWithInputBehavior(result);

      return result;
    };
